import fetchAPI from '../utils/fetchApi';
import { transformSearchRequest } from '../../../server/transformers/clientConfigToBackendConfig';

export default ({ searchRequest, xsrfToken }) =>
  fetchAPI({
    method: 'POST',
    url: '/lp/api/listings',
    payload: { ...transformSearchRequest(searchRequest) },
    xsrfToken,
  });
